

function getURLDetails(location) {
  const pathSplit = location.pathname.split('/')
  const [_idReadOnly] = pathSplit[pathSplit.length - 1].split(':')
  const [_id, isReadOnly] = _idReadOnly.split('&')
  return { _id, isReadOnly }
}

export{getURLDetails}